import { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useCanManageAlertConfig } from '@packages/components/alert-configuration-rules/use-can-manage-alert-config/use-can-manage-alert-config';

const AlertConfigurationsPage = lazy(
  () => import('./pages/alert-configurations/alert-configurations.page'),
);

const AlertConfigurationRule = lazy(() => import('./pages/alert/alert.page'));
const AlertConfigurationManagement = lazy(
  () => import('./pages/alert-management/alert-management.page'),
);
const AlertConfigurationRequest = lazy(
  () =>
    import('./pages/alert-management-request/alert-management-request.page'),
);

const SuppressionConfigurationRule = lazy(
  () => import('./pages/suppression/suppression.page'),
);

export const ConfigurationRulesRoutes = () => {
  const canManageAlertConfig = useCanManageAlertConfig();

  return (
    <Routes>
      <Route index element={<AlertConfigurationsPage />} />
      {canManageAlertConfig && (
        <>
          <Route
            path="/management"
            element={<AlertConfigurationManagement />}
          />
          <Route
            path="/management/request"
            element={<AlertConfigurationRequest />}
          />
        </>
      )}
      <Route path="/alerts/:alertId" element={<AlertConfigurationRule />} />
      <Route
        path="/suppressions/:suppressionId"
        element={<SuppressionConfigurationRule />}
      />
    </Routes>
  );
};
